module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.a4c0fa83.svg";